import { useEffect } from 'react';
import Cookies from 'js-cookie';

import useUiToasts, { createToastConfig, WARNING } from '../../stores/ToastStore';

const NG1_NAV_ERROR_COOKIE = 'ng1QueryError';

/**
 * Top-level~ish container which displays redirection warnings as toast messages.
 *
 * These warnings come from the ng1QueryError cookie.
 *
 * @param {React.PropsWithChildren<{}>} props
 */
export default function Ng1NavErrorManager(props) {
    const { children } = props;
    const [, uiToastActions] = useUiToasts();

    useEffect(() => {
        const queryError = Cookies.get(NG1_NAV_ERROR_COOKIE);

        if (queryError) {
            Cookies.remove(NG1_NAV_ERROR_COOKIE);

            uiToastActions.createToast(createToastConfig(WARNING, queryError));
        }
    }, [uiToastActions]);

    return children;
}
